import { useQuery } from '@tanstack/react-query';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { ConversationListItem } from './types';

export function useConversations(clientId?: string) {
  const { flagEnabledSiestaChats } = useFlags();
  return useQuery<ConversationListItem[]>({
    queryKey: ['conversations', { clientId }],
    // Backend returns 404 on this route when Siesta chats are off, so don't request it then.
    enabled: flagEnabledSiestaChats,
    // Poll while the list is open so a turn moving to processing, then unread, shows without a manual refresh.
    refetchInterval: 4000,
  });
}
